import { FC, memo } from "react";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";
import styled from "styled-components";
import { ButtonTone } from "../Button/Button.style";
import { textLink } from "../LinkButton/LinkButton";

interface LinkProps extends RouterLinkProps {
  tone?: ButtonTone;
}

// Navigation in text. It looks like a LinkButton of the same tone.
const Wrapper = styled(RouterLink)<{ $tone: ButtonTone }>`
  ${textLink}
`;

const Link: FC<LinkProps> = ({ tone = "primary", ...otherProps }) => (
  <Wrapper $tone={tone} {...otherProps} />
);

export default memo(Link);
